import React, { Component } from 'react';
import { settings } from 'helpers/Settings';
import PropTypes from 'prop-types';

import Text from 'components/Text';

// Styles
import './emergencyMessage.styles.scss';

export default class Alert extends Component {
    render() {
        const { isUserLogged } = this.props;
        if (isUserLogged || !settings().show_emergency_message) {
            return null;
        }

        return (
            <div className="alert">
                <Text textKey="shoppinglist_emergency_message" />
            </div>
        );
    }
}

Alert.propTypes = {
    isUserLogged: PropTypes.bool,
};
